import React, { useState } from 'react';

import {
  View,
} from '@uncinc/react-drupal-core';

import './style.scss';

const LatestEntitiesSmall = ({ blockTitle, block, locationIds }) => {
  const [currentPage, setCurrentPage] = useState(0);

  return (
    <div className="LatestEntitiesSmall">
      {/* Start Content */}
      {locationIds.size > 0 && (
        <View
          className="LatestEntitiesSmall__view"
          page={currentPage}
          args={locationIds.size > 0 ? [locationIds.toJS().join('+')] : ['all']}
          id="latest_location_content"
          setCurrentPage={setCurrentPage}
          blockTitle={blockTitle}
          display={block}
        />
      )}
      {/* End Content */}
    </div>
  );
};

export default LatestEntitiesSmall;
